export default "__VITE_ASSET__BF9MCI6b__"